module.exports = __webpack_public_path__ + "img/icon_selected.a7e42bae.svg";